export default class ProductMattress {
    constructor() {
        this.init();
        this.hideBaseOption = this.hideBaseOption.bind(this);

        this.optionRemoved = false;
        this.isMattress = true;
    }

    // Will wait for the spinner to finish loading.
    waitForElement(query, timeout = 10000) {
        return new Promise((resolve, reject) => {
            const startTime = Date.now();
            const tryQuery = () => {
                const elem = document.querySelector(query);
                if (elem) resolve(elem); // Found the element
                else if (Date.now() - startTime > timeout) resolve(null); // Give up eventually
                else setTimeout(tryQuery, 10); // check again every 10ms
            };
            tryQuery(); // Initial check
        });
    }

    // Will hide the "add base" dropdown option
    hideBaseOption() {
        const option = document.querySelector('.soap-product-selector div[footboard-product]');

        if (!option) {
            this.optionRemoved = true;
            return;
        }

        // Checks to see if the option is the base option
        if (option && option.querySelector('.soap-product-selector__dropdown__label') && option.querySelector('.soap-product-selector__dropdown__label').textContent.toLowerCase().includes('base')) {
            option.remove();
            this.optionRemoved = true;
        }
    }

    // Will add the Mattress CTA to the form above the button.
    addCTA() {
        const footer = document.querySelector('.soap-product-selector__footer');
        if (!footer) return;

        const cta = document.querySelector('.js-mattress-cta');
        if (!cta) {
            return;
        }

        cta.classList.remove('hidden');

        footer.insertAdjacentElement('beforebegin', cta);
    }

    // Will check the article element to see if any of the classes contain 'mattress'
    checkIfMattress() {
        const classes = document.querySelector('.single-product-details');
        if (!classes) return false;

        const containsMattress = Array.from(classes.classList).filter(c => c.includes('mattress'));

        const h1 = document.querySelector('h1');

        if (!h1) return containsMattress.length > 0;

        return h1.textContent.toLowerCase().includes('mattress') || containsMattress.length > 0;
    }

    async init() {
        this.isMattress = this.checkIfMattress();
        if (!this.isMattress) {
            return;
        }

        const check = await this.waitForElement('.soap-product-selector__dropdown');
        if (!check) {
            return;
        }
        this.hideBaseOption();

        if (!this.optionRemoved) return;

        this.addCTA();
    }
}

new ProductMattress();
